import axios from "axios"
import { API_URLS } from "../constants/ApiUrls"
import { format } from "date-fns"


const objectToQueryString = (payload: any) => {
    let baseQuery = `?date_range=${format(payload.startDate, 'yyyy-MM-dd')}&date_range=${format(payload.endDate, 'yyyy-MM-dd')}`
    if (payload.businessEntity && payload.businessEntity !== 'all')
        baseQuery = `${baseQuery}&business_entity=${encodeURIComponent(payload.businessEntity)}`;

    if (payload.operatingAsset && payload.operatingAsset !== 'all')
        baseQuery = `${baseQuery}&operating_asset=${encodeURIComponent(payload.operatingAsset)}`;

    if (payload.kpiName)
        baseQuery = `${baseQuery}&kpi_name=${payload.kpiName}`;

    if (payload.siteName && payload.siteName.length > 0) {
        const siteQuery = payload.siteName.map((s: string) => encodeURIComponent(s)).join(`&sites=`);
        baseQuery = `${baseQuery}&sites=${siteQuery}`
    }
    if (payload.year && payload.year) {
        baseQuery = `${baseQuery}&year=${encodeURIComponent(payload.year)}`
    }

    return baseQuery;
}

export const fetchKpiCountsApi = async (payload: any) => {
    const query = objectToQueryString(payload);
    const response = await axios.get(`${API_URLS.KPI_REPORTING}/count${query}`);
    if (response.status === 200) {
        return response.data;
    }
    return null;
}

export const fetchKpiInsightApi = async (payload: any) => {
    const query = objectToQueryString(payload)
    const response = await axios.get(`${API_URLS.KPI_REPORTING}/insight${query}`);
    if (response.status === 200) {
        return response.data;
    }
    return null;
}

export const fetchKpiTrendChartDataApi = async (payload: any) => {
    let query = objectToQueryString(payload);
    if (payload.kpi) {
        query = `${query}&kpi=${payload.kpi}`
    }
    const response = await axios.get(`${API_URLS.KPI_REPORTING}/all-ytd${query}`);
    if (response.status === 200) {
        return response.data;
    }
    return null;
}

export const downloadKPIInsights = async (payload: any) => {
    let query = objectToQueryString(payload);
    if (payload.kpi) {
        query = `${query}&kpi=${payload.kpi}`
    }
    try {
        const response = await axios.get(`${API_URLS.KPI_REPORTING}/kpi/download${query}`, {
            responseType: "blob"
        });
        if (response.status === 200) {
            const disposition = response.headers['content-disposition'];
            let filename = `${payload.kpiName}_${format(payload.startDate, 'yyyy-MM-dd')}_${format(payload.endDate, 'yyyy-MM-dd')}.csv`;

            if (disposition && disposition.indexOf('attachment') !== -1) {
                const matches = disposition.match(/filename="(.+)"/);
                if (matches && matches[1]) {
                    filename = matches[1];
                }
            }
            const blob = response.data;
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.click();
        }
    }
    catch (error) {
        // swallow error
    }
    return true;
}
